import React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// view components
import Search from 'components/UI/PageSearch/index'
import AccountFilter from './components/Filter'
import GroupSecurity from 'containers/Security/components/GroupSecurity'
import ObjectSecurity from 'containers/Security/components/ObjectSecurity/index'
import SecurityProfiles from 'containers/Security/components/SecurityProfiles/index'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const ContentContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;

  .MuiTabs-root {
    margin: 0;
  }
`

const Security: React.FC = () => {
  const { isAdmin } = useCurrentUser()

  const [tab, setTab] = React.useState(0)

  const handleSetTab = (_, value: number) => setTab(value)

  return (
    <>
      <Helmet>
        <title>Skefto - Security</title>
      </Helmet>
      <MainLayoutContainer CTA={<Search name={'name'} filter={isAdmin ? AccountFilter : null} />}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <ContentContainer>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Profiles' />
              <Tab label='Object Security' />
              <Tab label='Group Security' />
            </Tabs>

            {tab === 0 && <SecurityProfiles />}
            {tab === 1 && <ObjectSecurity />}
            {tab === 2 && <GroupSecurity />}
          </ContentContainer>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Security
